module.exports = __webpack_public_path__ + "media/images/sample/point-a677083491400d269688d96568dbee2f.png";